import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const CanvasWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="canvasWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="canvasWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="canvasWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="canvasWriterFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="canvasWriterFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="canvasWriterFormRootUrl"
        label="rootUrl"
        name="properties.rootUrl"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter root URL"
        error={errors?.properties?.rootUrl?.message}
      />
      <FormField
        controlId="canvasWriterFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter path"
        required
        error={form.formState.errors.properties?.path?.message}
      />
      <FormField
        controlId="canvasWriterFormAccessToken"
        label="accessToken"
        name="properties.accessToken"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter access token"
        error={errors?.properties?.accessToken?.message}
      />
      <FormField
        controlId="canvasWriterFormSleepInMilliSeconds"
        label="sleepInMilliSeconds"
        name="properties.sleepInMilliSeconds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        error={errors?.properties?.sleepInMilliSeconds?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default CanvasWriterForm;
